export class UseSelectEntityItemsUtils {
  private constructor() {}

  public static entityIdGetter = (entity: { id: string }): string => entity.id;
}
